import classnames from 'classnames';
import { useImperativeHandle, useRef } from 'react';
import * as React from 'react';
import './styles/ModalBox.scss';
import { useKeyboardTrap } from '../hooks';
import { StrategyType } from '../types/keyboardTrap';

interface ModalBoxProps {
    focusTrapStrategy?: StrategyType;
    className?: string;
    role?: string;
    isActive?: boolean;
    isFocusTrapActive?: boolean;
    rounded?: boolean;
    // eslint-disable-next-line react/no-unused-prop-types
    ref?: React.ForwardedRef<HTMLDivElement>;
    children?: React.ReactNode;
    ariaLabel?: string;
}

const ModalBox = React.forwardRef<HTMLDivElement | null, ModalBoxProps>(({
    focusTrapStrategy,
    children,
    className,
    role = 'dialog',
    isActive = true,
    isFocusTrapActive,
    rounded = false,
    ariaLabel,
}, ref) => {
    const innerRef = useRef<HTMLDivElement>(null);

    useKeyboardTrap(innerRef, isFocusTrapActive ?? isActive, focusTrapStrategy);
    useImperativeHandle(ref, () => innerRef.current!, []);

    const classes = classnames(
        'palette-modal-box',
        { 'palette-modal-box--active': isActive },
        { 'palette-modal-box--rounded': rounded },
        className,
    );

    return (
        <div
            ref={innerRef}
            aria-describedby="modal-description"
            aria-label={ariaLabel}
            aria-labelledby="modal-title"
            aria-modal={isActive || undefined}
            className={classes}
            role={isActive ? role : undefined}
        >
            {children}
        </div>
    );
});

ModalBox.displayName = 'ModalBox';

export default ModalBox;
